
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS'
export const SET_DEPARTMENT = 'SET_DEPARTMENT'
export const SET_META = 'SET_META'
export const SET_PLANS = 'SET_PLANS'
export const SET_TP_PARAMS = 'SET_TP_PARAMS'
export const SET_SEARCH_FILTERS = 'SET_SEARCH_FILTERS'
export const SET_LOADING = 'SET_LOADING'
export const SET_PARTNERSHIPS = 'SET_PARTNERSHIPS'
export const SET_CURRENCIES = 'SET_CURRENCIES'
export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_VACATION = 'SET_VACATION'
export const SET_LAST_VACATION = 'SET_LAST_VACATION'
